import React from 'react'
import {
  FlyoutOnboardingSectionName,
  Sections,
} from '../../modules/flyOutOnboarding/reducer'
import { FormikProps } from 'formik'
import { FlyoutCompanyInfo } from './FlyoutCompanyInfo'
import { useStyles } from './FlyoutCompanyDetails.styles'
import { FormLockedType } from '../../types/FormLockedType'
import { defaultNow } from '../../common/utils/dateTimeNow'
import { FlyOutOnboardingAdhere } from '../FlyOutOnboardingAdhere'
import { awsCompanyDetailRequirementsLink } from '@labrav/common'

export type FlyOutCompanyDetailsProps = {
  companyDetails: FormikProps<Sections>
}
export const FlyOutCompanyDetails: React.FC<
  FlyOutCompanyDetailsProps & FormLockedType
> = ({ companyDetails, isFormLocked }) => {
  const { classes } = useStyles()
  const requirementsLink = awsCompanyDetailRequirementsLink
  return (
    <div className={classes.container}>
      <FlyoutCompanyInfo
        companyDetails={companyDetails}
        defaultNow={defaultNow}
        isFormLocked={isFormLocked}
      />
      <FlyOutOnboardingAdhere
        requirementsLink={requirementsLink}
        sectionName={FlyoutOnboardingSectionName.LABRA_PARTNER_DETAILS}
        isFormLocked={isFormLocked}
      />
    </div>
  )
}
